import { connect } from 'react-redux';
import { cancelReturnLabelRequest } from '../store/returns/returns.actions';
import { CancelPromptModal } from '../components/modals/cancel-prompt-modal';

const mapStateToProps = (state, props) => {
  const { title, message, confirmation } = props;
  return {
    title,
    message,
    confirmation,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { fulfillmentIds, fromOrderDetails, modalFrameworkMethods } = props;
  const actions = {
    cancel: () => {
      dispatch(cancelReturnLabelRequest(fulfillmentIds, fromOrderDetails));
      modalFrameworkMethods.closeModal();
    },
  };
  return { actions };
};

export const CancelReturnLabelPromptModalContainer = connect(mapStateToProps, mapDispatchToProps)(CancelPromptModal);
